const post = require('./post')

/**
 * @namespace nexus.uIConfig.userUIConfig
*/

module.exports = { post }
